import '.ak{border-radius:1.25rem;}.ssr-plugin'
import '.az{overflow:hidden;}.ssr-plugin'
import '.hf{border:var(--border-default);}.ssr-plugin'
import '.hg{min-height:420px;}.ssr-plugin'
import '.ap{height:100%;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import { Style, styled } from 'inlines'

export interface SlideShareEmbedProps {
  src: string
  style?: Style
  className?: string
}

export const SlideShareEmbed = ({
  src,
  style,
  className,
}: SlideShareEmbedProps) => {
  return (
    <styled.div className={`${className} ak az hf hg ap d e`}
      style={{
        ...style,
      }}
    >
      <iframe
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        marginWidth={0}
        marginHeight={0}
        scrolling="no"
        allowFullScreen
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          flex: 1,
        }}
      />
    </styled.div>
  )
}
